export enum ResetPasswordStatus {
    Success = 0,
    Failed = 1
}
